export default {
  point: 'Punkt',
  point_other: 'Punkte',
  titles: {
    earn: 'Verdiene Punkte, erhalte Rabatte 💵',
    redeem: '{{discount}}% verdient 🥳',
  },
  description:
    'Nachdem du deine Prämie für Rabatte einlöst, gehst du nicht auf 0 Punkte zurück, sondern sammelst weiter Punkte ab {{points}}.',
};
